
<template>
  <v-autocomplete
    v-model="localValue"
    label="Vuetify Version"
    :rules="[rules.required]"
    :items="versions"
    :loading="loading"
    :hint="hint"
    dense
    outlined
    persistent-hint
    v-bind="$attrs"
    v-on="$listeners"
  >
    <v-list-item-content
      slot="item"
      slot-scope="{ item }"
      :class="{
        'orange--text text--darken-3': item === tags.next,
        'green--text': item === tags.latest
      }"
    >
      <v-list-item-title>{{ item }}</v-list-item-title>
    </v-list-item-content>
  </v-autocomplete>
</template>

<script>
  import { fetchVersionsFromNpm } from '@/lib/fetchVersions'

  import StringValue from '@/components/form/mixins/stringValue'
  import RequiredRules from '@/components/form/mixins/required'
  export default {
    name: 'FormVuetifyVersionSelect',
    mixins: [StringValue, RequiredRules],
    props: {
      noHint: Boolean,
      unlimited: Boolean,
    },
    data () {
      return {
        loading: false,
        hasError: false,
        latest: '',
        versions: [],
        tags: {},
      }
    },
    computed: {
      hint () {
        if (this.noHint) return ''
        return this.localValue && this.localValue !== this.latest
          ? `Please check if bug exists on ${this.latest} before submitting`
          : ''
      },
    },
    async created () {
      try {
        const { tags, versions } = await fetchVersionsFromNpm('vuetify', this.unlimited ? '>=2' : '^2.7.0 || ^3.3.0')
        this.tags = tags
        this.versions = versions
        this.latest = versions[0] || ''
      } catch (err) {
        this.hasError = true
        this.$emit('error', err.message)
        console.error(err.message)
      } finally {
        this.loading = false
      }
    },
  }
</script>

<style lang="scss" scoped>

</style>
